import emailjs from "@emailjs/browser"

export function sendEmail(formData) {
  emailjs
    .send("service_if6mny5","template_b2wpqal", formData,"8ezMRd8Eg9yqNRO5lsXCs")
    .then((res) => {
      console.log("Email successfully sent!");
    })
    .catch((err) => {
      console.error("Failed to send email:", err);
    });
}
